import type { VoidFunctionComponent } from 'react';

import { icons } from '../../../generic/Icon';
import SettingsTableRowActions from '../../shared/SettingsTableRowActions';

type ActionMenuDropdownProps = {
  tokenId: number;
  onSetTokenToEdit: (tokenId: number) => void;
  onDeleteToken: (tokenId: number) => void;
};

const ActionMenuDropdown: VoidFunctionComponent<ActionMenuDropdownProps> = ({
  tokenId,
  onSetTokenToEdit,
  onDeleteToken,
}) => (
  <SettingsTableRowActions>
    <SettingsTableRowActions.IconButton
      tooltipId={`edit-api-token-${tokenId}`}
      tooltip="Edit"
      icon={icons.pencil}
      onClick={() => onSetTokenToEdit(tokenId)}
    />
    <SettingsTableRowActions.IconButton
      tooltipId={`delete-api-token-${tokenId}`}
      tooltip="Delete"
      icon={icons.trashRegular}
      onClick={() => onDeleteToken(tokenId)}
    />
  </SettingsTableRowActions>
);

export default ActionMenuDropdown;
